import { SeparatedStringBy } from "utils/stringTools";

type FilterValue = string | number | boolean | null;
type FilterCondition =
  | [string, string, FilterValue]
  | (string | FilterCondition)[];
type FilterExpression = FilterCondition | FilterValue;
export const generateFiltersByAcceptingCustomStringInput = (
  filter: FilterExpression
): FilterExpression => {
  if (Array.isArray(filter)) {
    if (
      filter.length >= 3 &&
      typeof filter[0] === "string" &&
      typeof filter[1] === "string" &&
      typeof filter[2] === "string" &&
      filter[2].includes(",")
    ) {
      const fieldName = filter[0];
      const operator = filter[1];
      const values = SeparatedStringBy(filter[2], ",");

      if (values.length > 1) {
        const conditions: (string | string[])[] = [];
        values.forEach((value, index) => {
          if (index > 0) {
            conditions.push("or");
          }
          conditions.push([fieldName, operator, value]);
        });

        return conditions;
      }
    }

    return filter.map((item) =>
      Array.isArray(item)
        ? generateFiltersByAcceptingCustomStringInput(item)
        : item
    ) as FilterCondition;
  }
  return filter;
};
